import axios from 'axios';
import { ref } from 'vue';
import { getSubdomain } from '../helpers/helper';

/** The hubs the signed-in person works in, with their role in each (SSO's /api/my-hubs). */
export const useMyHubs = () => {
  const hubs = ref([]);
  const failed = ref(false);

  const load = async () => {
    try {
      const { data } = await axios.get('/api/sso/api/my-hubs');
      hubs.value = (data?.data ?? []).map((hub) => ({ ...hub, current: hub.subdomain_name === getSubdomain() }));
      failed.value = false;
    } catch {
      failed.value = true;
    }
  };

  return { hubs, failed, load };
};
